import React from "react";
import styles from "../PreCallFeature/PreCallFeature.module.css";
import TitleBar from "../../TitleBar/TitleBar";

const PreCallFeature = ({ preCallfeaturedata }) => {
  const cardsData = (preCallfeaturedata?.cards || []).map((c) => ({
    title: c.title,
    desc: c.desc,
    img: c.img?.src,
  }));

  return (
    <div className={styles.MianDiv}>
      <div className={styles.containerBox}>
        <div className={styles.TitleSection}>
          <TitleBar blocks={preCallfeaturedata?.heading} />
        </div>
        <div className={styles.container}>
          <section className={styles.section}>
            <div className={styles.cardsWrapper}>
              {cardsData.map((card, i) => (
                <div key={i} className={styles.card}>
                  <div className={styles.text}>
                    <h3>{card.title}</h3>
                  </div>
                  <div className={styles.descP}>
                    <p>{card.desc}</p>
                  </div>
                  <div className={styles.imgWrapper}>
                    <img src={card.img} alt={card.title} />
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <div className={styles.ocean}>
          <div className={styles.wave}></div>
          <div className={styles.wave}></div>
          <div className={styles.wave}></div>
        </div>
      </div>
    </div>
  );
};

export default PreCallFeature;
